/** The "New patients from ads" form's rules: the period it defaults to, and what a row sends. */

/** The last full calendar month before `today` (YYYY-MM-DD), the period practices usually report. */
export function lastFullMonth(today: Date): { start: string; end: string } {
  const start = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1));
  const end = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 0));
  return { start: start.toISOString().slice(0, 10), end: end.toISOString().slice(0, 10) };
}

export interface OutcomeDraft {
  callersMatched: string;
  newPatientHouseholds: string;
  newPatients: string;
}

export const EMPTY_DRAFT: OutcomeDraft = {
  callersMatched: '',
  newPatientHouseholds: '',
  newPatients: '',
};

/** A typed count: blank is "not sent" (null), never zero; anything but a whole number is refused. */
export function parseCount(value: string): number | null | 'invalid' {
  const v = value.trim();
  if (v === '') return null;
  return /^\d{1,6}$/.test(v) ? Number(v) : 'invalid';
}

/**
 * The rows to send: one per campaign with at least one count filled in. A count that is not a whole
 * number is named back instead of sent.
 */
export function outcomeRows(drafts: Record<string, OutcomeDraft>):
  | {
      ok: true;
      rows: Array<{
        campaign: string;
        callersMatched: number | null;
        newPatientHouseholds: number | null;
        newPatients: number | null;
      }>;
    }
  | { ok: false; invalid: string[] } {
  const rows = [];
  const invalid: string[] = [];
  for (const [campaign, draft] of Object.entries(drafts)) {
    const callersMatched = parseCount(draft.callersMatched);
    const newPatientHouseholds = parseCount(draft.newPatientHouseholds);
    const newPatients = parseCount(draft.newPatients);
    if ([callersMatched, newPatientHouseholds, newPatients].includes('invalid')) {
      invalid.push(campaign);
      continue;
    }
    if (callersMatched === null && newPatientHouseholds === null && newPatients === null) continue;
    rows.push({
      campaign,
      callersMatched: callersMatched as number | null,
      newPatientHouseholds: newPatientHouseholds as number | null,
      newPatients: newPatients as number | null,
    });
  }
  return invalid.length > 0 ? { ok: false, invalid } : { ok: true, rows };
}
